function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.77086 6L11.6335 2.13816C12.1222 1.6495 12.1222 0.855676 11.6335 0.366982C11.1436 -0.122327 10.3512 -0.122327 9.86118 0.366982L5.99967 4.22882L2.13816 0.366982C1.64824 -0.122327 0.856431 -0.122327 0.366464 0.366982C-0.122155 0.855642 -0.122155 1.64947 0.366464 2.13816L4.22864 6L0.366464 9.86251C-0.122155 10.3512 -0.122155 11.1443 0.366464 11.633C0.856382 12.1223 1.64819 12.1223 2.13816 11.633L5.99967 7.77118L9.86118 11.633C10.3504 12.1223 11.1436 12.1223 11.6335 11.633C12.1222 11.1444 12.1222 10.3512 11.6335 9.86251L7.77086 6Z"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.c246581f.svg";
export { ForwardRef as ReactComponent };